module.exports = __webpack_public_path__ + "img/ecommerce-empty-list.1c8103df.svg";